import { workReportLineStatus } from '../../../../utils/dataStatus';
import InputUnitMeasure from '../../CustomCells/inputUnitMeasure/InputUnitMeasure';
import './InputUnitMeasureColumn.scss';

const EDITABLE_STATES = [workReportLineStatus.devolver, workReportLineStatus.pendiente];

const InputUnitMeasureColumn = ({ disabledAllEdition, forceWindow }) => ({
  component: (props) => <InputUnitMeasure forceWindow={forceWindow} {...props} />,
  deleteValue: ({ rowData }) => rowData,
  disabled: ({ rowData }) =>
    !EDITABLE_STATES.includes(rowData?.stateOfUnitMeasure) ||
    disabledAllEdition ||
    !rowData?.enableNotification,
  headerClassName: 'input-unit-measure-header',
  copyValue: ({ rowData }) => rowData?.unitMeasureValue,
  pasteValue: ({ value, rowData }) => {
    if (rowData?.flujoMobile) {
      return null;
    }

    return parseFloat(value);
  },
  minWidth: 110
});

export default InputUnitMeasureColumn;
